const ADDENDUM = "addendum";
const CONVERSATION_RFX_PRE_SUBMISSION = "conversation_rfx_pre_submission";
const QUOTE_FILE_RESPONSE = "rfq_quote_file_response";

const RETURNABLE_SCHEDULE_FILE_RESPONSE =
	"rfq_returnable_schedule_file_response";
const RETURNABLE_SCHEDULE_FILE_TEMPLATE =
	"rfq_returnable_schedule_file_template";
const RETURNABLE_SCHEDULE_QUESTIONNAIRE_FILE_RESPONSE =
	"rfq_returnable_schedule_questionnaire_file_response";

const RFQ_QUOTE_FILE_TEMPLATE_TYPE = "rfq_quote_file_template";

const FLEXIBLE_QUOTE_FILE_RESPONSE = "flexible_quote_file";

export const FILE_UPLOAD_TYPES = {
	ADDENDUM,
	CONVERSATION_RFX_PRE_SUBMISSION,
	FLEXIBLE_QUOTE_FILE_RESPONSE,
	QUOTE_FILE_RESPONSE,
	RETURNABLE_SCHEDULE_FILE_RESPONSE,
	RETURNABLE_SCHEDULE_FILE_TEMPLATE,
	RETURNABLE_SCHEDULE_QUESTIONNAIRE_FILE_RESPONSE,
	RFQ_QUOTE_FILE_TEMPLATE_TYPE,
};
